import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PlatformName } from '@shared/models/user';
import { BrandNamePipe } from '@lib/rs-ngx';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mgt-platform-chip',
  templateUrl: './platform-chip.component.html',
  imports: [BrandNamePipe, MatIcon],
  styleUrls: ['./platform-chip.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PlatformChipComponent {

  @Input() public platforms!: {
    name: PlatformName;
    isManager?: boolean
  }[];

  constructor() {

  }
}
